import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { useIsDesktop } from '../../Utils/productPageUtils';
import { customStyles } from '../../Utils/redirections';
import { MyloLogoLoader } from '../MyloLogoLoader';
import { disableTrueCaller, trueCallerHandler } from './utils';

const LoginPopup = dynamic(() => import('./Login'), {
  ssr: false,
});
const Modal = dynamic(() => import('react-modal'), {
  ssr: false,
});

export default function LoginPopupContainer(props) {
  const {
    closeModal,
    showLoginPopup,
    handleSuccess,
    setShowLoginPopup,
    fromPayment,
    otpVerificationParamsData,
    desktopLogin,
  } = props;
  const [showOTPLogin, setShowOTPLogin] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const Styles = desktopLogin
    ? customStyles('10%', '', '', '', true)
    : customStyles('', '', '0', '');
  const isDesktop = useIsDesktop();
  useEffect(() => {
    if (
      (isDesktop && showLoginPopup) ||
      (disableTrueCaller() && showLoginPopup)
    ) {
      setShowOTPLogin(true);
    } else {
      if (showLoginPopup) {
        trueCallerHandler(
          () => setShowOTPLogin(true),
          handleSuccess,
          setShowLoader,
        );
      }
    }
  }, [showLoginPopup]);

  // useEffect(() => {
  //     setShowLoginPopup(showOTPLogin);
  // }, [showOTPLogin]);

  return (
    <>
      {(showLoginPopup || desktopLogin) && (
        <Modal
          onRequestClose={closeModal}
          isOpen={showLoginPopup || desktopLogin}
          style={Styles}
        >
          <LoginPopup
            handleSuccess={handleSuccess}
            setShowLoginPopup={setShowLoginPopup}
            closeModal={closeModal}
            fromPayment={fromPayment}
            otpVerificationParamsData={otpVerificationParamsData}
            desktopLogin={desktopLogin}
          />
        </Modal>
      )}
      {showLoader && <MyloLogoLoader />}
    </>
  );
}
